var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.ready
      ? _c("aside", { staticClass: "app-loading" }, [
          _c("p", [_vm._v("Loading Online Scheduling...")]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.ready && _vm.clinic
      ? _c("aside", { staticClass: "onlineScheduling" }, [
          _c(
            "div",
            { staticClass: "content" },
            [
              _c("div", { staticClass: "onlineScheduling__main" }, [
                _c("span", { staticClass: "onlineScheduling__header" }, [
                  _vm._v("Schedule an Appointment in "),
                  _c("strong", [_vm._v(_vm._s(_vm.clinic.name))]),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass:
                      "btn-beltone onlineScheduling__changeLocations",
                    on: {
                      click: function ($event) {
                        return _vm.changeLocations()
                      },
                    },
                  },
                  [
                    _c("IconMapMarker"),
                    _vm._v(" "),
                    _c("span", [_vm._v("Change Locations")]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "onlineScheduling__steps" },
                  _vm._l(_vm.steps, function (s) {
                    return _c(
                      "div",
                      {
                        key: s.step,
                        staticClass: "onlineScheduling__step",
                        class: [
                          _vm.getStepState(s.step),
                          { "is-clickable": _vm.canNavigateToStep(s.step) },
                        ],
                        attrs: {
                          tabindex: _vm.canNavigateToStep(s.step) ? 0 : null,
                          role: _vm.canNavigateToStep(s.step) ? "button" : null,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.goToStep(s.step)
                          },
                          keydown: [
                            function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              $event.preventDefault()
                              return _vm.goToStep(s.step)
                            },
                            function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "space",
                                  32,
                                  $event.key,
                                  [" ", "Spacebar"]
                                )
                              ) {
                                return null
                              }
                              $event.preventDefault()
                              return _vm.goToStep(s.step)
                            },
                          ],
                        },
                      },
                      [
                        _c(s.icon, {
                          tag: "component",
                          staticClass: "onlineScheduling__step-icon",
                          attrs: { colorState: _vm.getStepState(s.step) },
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          { staticClass: "onlineScheduling__step-header" },
                          [_vm._v("Step " + _vm._s(s.step))]
                        ),
                        _vm._v(" "),
                        _c(
                          "label",
                          { staticClass: "onlineScheduling__step-copy" },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "onlineScheduling__step-copy-full",
                              },
                              [_vm._v(_vm._s(s.label))]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "onlineScheduling__step-copy-short",
                              },
                              [_vm._v(_vm._s(s.shortLabel))]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "onlineScheduling__step-bar",
                        }),
                      ],
                      1
                    )
                  }),
                  0
                ),
              ]),
              _vm._v(" "),
              _vm.step === 1 ? _c("step-1") : _vm._e(),
              _vm._v(" "),
              _vm.step === 2
                ? _c("step-2", {
                    attrs: { clinicId: _vm.clinic.id, dealerId: _vm.dealerId },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.step === 3
                ? _c("step-3", {
                    attrs: {
                      dealerId: _vm.dealerId,
                      "hide-sms-consent": _vm.shouldHideSmsConsent,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.step === 4
                ? _c("step-4", { attrs: { dealerId: _vm.dealerId } })
                : _vm._e(),
            ],
            1
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }